import store from 'store';
import {SET_VAT_ON} from 'store/modules/common/common';
import {booleanConverters} from 'adapters/converters';
import UrlAdapter from 'adapters/UrlAdapter';

function setStoreFromUrl () {
  const urlAdapter = new UrlAdapter({
    with_vat: {
      converters: booleanConverters
    }
  });
  const urlVatValue = urlAdapter.load().with_vat;
  const vatOn = typeof urlVatValue === 'boolean' ? urlVatValue : store.getters['common/vatOn'] || false;
  store.dispatch(`common/${SET_VAT_ON}`, vatOn);
}

export default function routePostprocessor () {
  setStoreFromUrl();
}
